import React, { Component } from 'react';
import { i18nIntl, convertObjectToArray, getPlatformName } from '../lib/ep.js';
import { injectIntl, FormattedMessage } from 'react-intl';
import { find as _find, size as _size, debounce as _debounce, orderBy as _orderBy , deburr as _deburr } from 'lodash';

import { logs_action, logs_type } from '../components/account/bootstrap';

import { SquaredButton } from '../components/builder/ActionButton';
import ActionLink from '../components/builder/ActionLink';
import ButtonCollection from '../components/builder/ButtonCollection';
import FloatingLayer from '../components/builder/FloatingLayer';
import Model from '../components/builder/Model';
import SearchField from '../components/builder/SearchField';
import Select from '../components/builder/Select';
import Spinner from '../components/builder/Spinner';
import Tooltip from '../components/builder/Tooltip';

import InfiniteScroll from '../components/hoc/InfiniteScroll';
import Module from '../components/ui_items/Module.js';
import SectionHeader from '../components/ui_items/SectionHeader.js';
import OwnerPromoWrapper from '../components/ui_items/OwnerPromoWrapper.js';

const LoadingBlock = (props) => {
	return (
		<div class="gui_pos_abs gui_loading_whole">
			<Spinner force_bg={false} />
		</div>
	)
};

class AgentsLogs extends Component {
	constructor(props) {
		super(props);

		this.nullazer = '__@@__';

		this.agent_id = (props.agent_id != undefined) ? props.agent_id : false;
		this.agents = (props.agents != undefined) ? props.agents : [];
		this.labels = (props.labels != undefined) ? props.labels : [];
		this.roles = (props.roles != undefined) ? props.roles : [];

		this.state = {
			data_to_display:false,
			filters:{
				agent_id:'----',
				action:'----',
				type:'----',
				target:"",
			},
			filtered:[],
			in_progress:false,
			logs:(props.logs != undefined) ? props.logs : [],
			total_filtered_logs:0,
			loading:true,
		};

		this.logs_security = props.type == 'security' ? true : false;
		this.promotion = (props.type == 'security' && props.promotion != undefined) ? props.promotion : false;
		this.agents_selector = [];
		this.actions_selector = [];
		this.types_selector = [];
		this.onChangeDebounced = _debounce(this.onChangeDebounced, 1000);
		this.fields_not_allowed = ['expiration_date','pp_transaction','pp_payment_date','payer_fbuid','total','copyof','featured','template_id','use_full_entries_template','max_entries_row_height','min_friends_vote','only_friends_vote'];
	}

	onChangeDebounced() {
		this.setState({ logs:[] });
		this.fetchLogs(1, (d) => this.fetched(d.data));
	}

	componentDidMount() {
		this.fetchLogs(1, (d) => this.fetched(d.data));
		this.setState({...this.state});
	}

	componentWillMount() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		this.agents_selector.push({ k:'----', v:"-- " + i18n("***All") + " --"});
		this.agents.map((agent, a) => {
			this.agents_selector.push({'name':_deburr(agent.Agent.name + " " + agent.Agent.lastname), k:agent.Agent.id, v:agent.Agent.name + " " + agent.Agent.lastname + ((agent.Agent.id == this.agent_id) ? " (" + i18n("You") + ")" : "")});
		});

		this.agents_selector = _orderBy(this.agents_selector, ['name'], ['asc']);

		this.actions_selector.push({ k:'----', v:"-- " + i18n("***All") + " --"});
		$.each(logs_action, (a, action) => {
			if(this.logs_security){
				if(![3,10,11].includes(action.id))return true;
			}
			this.actions_selector.push({ k:action.id, v:action.label });
		});

		this.types_selector.push({ k:'----', v:"-- " + i18n("All") + " --"});
		$.each(logs_type, (t, type) => {
			if(this.logs_security){
				if(![2,14,15].includes(type.id))return true;
			}
			this.types_selector.push({ k:type.id, v:type.label });
		});

		//this.filter();
	}

	changeFilter(k, v) {
		this.state.filters[k] = v;
		if(k!='target'){
			this.filter();
			this.setState({...this.state});
		}else{
			this.setState({loading:true});
			this.onChangeDebounced();
		}
	}

	filter(cb) {
		this.state.logs = [];
		this.state.total_filtered_logs = 0;
		this.state.loading = true;
		this.setState({...this.state});
		this.fetchLogs(1, (d) => this.fetched(d.data));

		this.infinite.reset();
	}

	displayDataLayer(data) {
		this.setState({ data_to_display:data });
	}

	fetched(data) {
		this.state.logs = this.state.logs.concat(data);
		//this.filter();
		this.state.loading = false;
		this.setState({...this.state});
	}

	fetchLogs(page, cb) {
		var d = {};
		if(page) d.p = page;
	/*	if(this.logs_security) d.type = 'security';
		if(this.promotion) d.promotion_id = this.promotion.id;*/
		if(_size(this.state.filters)>0) d.filters = this.state.filters;
		//d.remotedb=1;
		this.setState({ loading:true });

		$.get('/agents/fetch_logs', d, (result) => {
			var has_more = true;

			if(this.state.total_filtered_logs == 0)this.state.total_filtered_logs = result.total;

			if(result.elements != undefined) {
				has_more = (_size(this.state.logs) + _size(result.elements) < result.total) ? true : false;
			}
			if(cb && result.status) cb({ data:result.elements, hasMore:has_more, page});
		}, 'JSON');
	}

	hideDataLayer() {
		this.setState({ data_to_display:false });
	}

	ensureAgent(agent) {
		if (agent == undefined) {
			return {Agent:{name:i18nIntl("Agent", this.props.intl),lastname:i18nIntl("Unknown", this.props.intl)}};
		}
		return agent;
	}

	getActionIcon(type) {
		var icon = false;

		switch(parseInt(type)) {
			case logs_type.TYPE_CREATE.id:
				icon = 'knk-add-item';
				break;
			case logs_type.TYPE_DELETE.id:
				icon = 'knk-delete';
				break;
			case logs_type.TYPE_ACTIVATE.id:
				icon = 'knk-on';
				break;
			case logs_type.TYPE_CHANGE.id:
				icon = 'knk-edit';
				break;
			case logs_type.TYPE_LOGIN.id:
				icon = 'knk-login';
				break;
			case logs_type.TYPE_LOGOUT.id:
				icon = 'knk-logout';
				break;
			case logs_type.TYPE_FINALIZED.id:
				icon = 'knk-ok';
				break;
			case logs_type.TYPE_REMOVE_PARTICIPANTS.id:
				icon = 'knk-remove-user';
				break;
			case logs_type.TYPE_ASSIGN_ROLE.id:
				icon = 'knk-add-user';
				break;
			case logs_type.TYPE_REMOVE_ROLE.id:
				icon = 'knk-remove-user';
				break;
			case logs_type.TYPE_REACTIVATE_SUBSCRIPTION.id:
				icon = 'knk-on';
				break;
			case logs_type.TYPE_CANCEL_SUBSCRIPTION.id:
				icon = 'knk-off';
				break;
			case logs_type.TYPE_DISABLE.id:
				icon = 'knk-off';
				break;
			case logs_type.TYPE_BLOCK.id:
				icon = 'knk-blocked';
				break;
			case logs_type.TYPE_UNBLOCK.id:
				icon = 'knk-unzipped';
				break;
		}

		return icon;
	}

	getActionText(log, subject) {
		const type = parseInt(log.type);
		
		var action_text = false;
		var values = {
			subject:subject,
		};

		switch(type) {
			case logs_type.TYPE_CREATE.id:
				action_text = "{subject} created {article} {target}";
				break;

			case logs_type.TYPE_CHANGE.id:
				action_text = "{subject} changed {article} {target}";
				break;

			case logs_type.TYPE_ACTIVATE.id:
				action_text = "{subject} activated {article} {target}";
				break;

			case logs_type.TYPE_DISABLE.id:
				action_text = "{subject} disabled {article} {target}";
				break;

			case logs_type.TYPE_DELETE.id:
				action_text = "{subject} deleted {article} {target}";
				break;

			case logs_type.TYPE_FINALIZED.id:
				action_text = "{subject} finished {article} {target}";
				break;

			case logs_type.TYPE_LOGIN.id:
				action_text = "{subject} logged in";
				break;

			case logs_type.TYPE_LOGOUT.id:
				action_text = "{subject} logged out";
				break;

			case logs_type.TYPE_ASSIGN_ROLE.id:
				action_text = "{subject} given {role} permissions to {target} for {label}";
				break;

			case logs_type.TYPE_REMOVE_ROLE.id:
				action_text = "{subject} removed {role} permissions to {target} for {label}";
				break;

			case logs_type.TYPE_REACTIVATE_SUBSCRIPTION.id:
				action_text = "{subject} reactivate {target}";
				break;

			case logs_type.TYPE_CANCEL_SUBSCRIPTION.id:
				action_text = "{subject} cancel {target}";
				break;

			case logs_type.TYPE_BLOCK.id:
				action_text = "{subject} blocked the {element} {target}";
				break;
			
			case logs_type.TYPE_UNBLOCK.id:
				action_text = "{subject} unblocked the {element} {target}";
				break;
				

		}

		let platform, platform_name, platform_base_url, target_name;

		switch(parseInt(log.action)) {
			case logs_action.ACTION_ACCOUNT.id:
				values.article = "***the";
				values.target = <strong>{this.props.intl.formatMessage({ id:"account" })}</strong>;
				break;

			case logs_action.ACTION_USER.id:
				if(type == logs_type.TYPE_DELETE.id){
					values.article = "***the";
					values.target = <span dangerouslySetInnerHTML={{ __html:this.props.intl.formatMessage({id:"user privacy of {email}"}, {email:'<strong>'+log.data.email+'</strong>'})}}></span>;
				}
				break;

			case logs_action.ACTION_AGENT.id:
				var modified_agent = this.agents.filter((obj) => { return (obj.Agent.id == log.target) ? true : false; })[0];

				modified_agent = this.ensureAgent(modified_agent);

				switch(type) {
					case logs_type.TYPE_CHANGE.id:
					case logs_type.TYPE_CREATE.id:
						if(log.target == this.agent_id) {
							values.article = "your";
							values.target = <strong>{this.props.intl.formatMessage({ id:"user profile" })}</strong>;
						} else {
							values.article = "the";
							values.target = <strong>{this.props.intl.formatMessage({ id:"user profile of {user}" }, { user:modified_agent.Agent.name + " " + modified_agent.Agent.lastname })}</strong>;
						}
						break;

					case logs_type.TYPE_ASSIGN_ROLE.id:
					case logs_type.TYPE_REMOVE_ROLE.id:
						const label_name = this.labels.filter((obj) => { return (obj.Label.id == log.data.label_id) ? true : false; })[0];

						values.label = <strong>{label_name!=undefined ? label_name.Label.name : 'unknown'}</strong>;
						values.role = <strong>{this.roles[log.data.role]}</strong>;
						values.target = <strong>{modified_agent.Agent.name} {modified_agent.Agent.lastname}</strong>;
						break;
				}
				break;

			case logs_action.ACTION_ORGANIZER.id:
				values.article = "***the";
				values.target = <strong>{this.props.intl.formatMessage({ id:"organizing brand {name}" }, { name:log.data.name })}</strong>;
				break;

			case logs_action.ACTION_PROMOTION.id:
			case logs_action.ACTION_EMAIL.id:
				//OJO pot ser un USER
				platform = log?.platform ?? 0;
				platform_name = getPlatformName(platform,false,false);
				platform_base_url = getPlatformName(platform,false,true);
				target_name = this.props.intl.formatMessage({ id:"{version} promotion" }, { version:this.props.intl.formatMessage({ id:platform_name }) });
				values.article = "***the";

				const deleted_user = log?.data?.name && log?.data?.email ? true : false;
				if(deleted_user){
					let name_user ='';
					let promotion_id = log.data.promotion_id;
					if(log.data.name)name_user += `${log.data.name} `;
					if(log.data.email)name_user += ` (${log.data.email})`;
					values.article = this.props.intl.formatMessage({ id:"the participant {name} in" }, { name:name_user });
					values.element = this.props.intl.formatMessage({ id:"the participant {name} in" }, { name:name_user });//Pel bloxk i unbloc
					values.target = <ActionLink _class={{other:'gui_force_bold'}} _href={platform_base_url + 'promotions/profile/' + promotion_id} _target="_blank" autotranslate={false}>{this.props.intl.formatMessage({ id:"{promotion} #{id}" }, { promotion:target_name, id:promotion_id })}</ActionLink>;
				}else if(parseInt(log.action) == logs_action.ACTION_EMAIL.id){
					values.target = <ActionLink _class={{other:'gui_force_bold'}} _href={platform_base_url + '/emails/edit/' + log.target} _target="_blank" autotranslate={false}>{this.props.intl.formatMessage({ id:"Email #{id}" }, { id:log.target })}</ActionLink>;
				}else{
					values.target = <ActionLink _class={{other:'gui_force_bold'}} _href={platform_base_url + 'promotions/profile/' + log.target} _target="_blank" autotranslate={false}>{this.props.intl.formatMessage({ id:"{promotion} #{id}" }, { promotion:target_name, id:log.target })}</ActionLink>;
				}

				break;

			case logs_action.ACTION_SWEEP.id:
				values.article = "the";
				values.target = <ActionLink _class={{other:'gui_force_bold'}} _href={'/sweeps/settings/' + log.target} _target="_blank" autotranslate={false}>{this.props.intl.formatMessage({ id:"Sweepstakes #{id}" }, { id:log.target })}</ActionLink>;
				break;

			case logs_action.ACTION_SUBSCRIPTION.id:
				values.target = <ActionLink _class={{other:'gui_force_bold'}} _href={'/plans'} _target="_blank" autotranslate={false}>{this.props.intl.formatMessage({ id:"Subscription #{id}" }, { id:log.target })}</ActionLink>;
				break;

			case logs_action.ACTION_IP.id:
				values.target = <strong>{log?.data?.ip ?? i18n("Unknown")}</strong>;
				values.element = "IP:";
				
				break;
			case logs_action.ACTION_DOMAIN.id:
				platform = log?.platform ?? 0;
				platform_name = getPlatformName(platform,false,false);
				platform_base_url = getPlatformName(platform,false,true);
				target_name = this.props.intl.formatMessage({ id:"{version} promotion" }, { version:this.props.intl.formatMessage({ id:platform_name }) });
				values.target = <ActionLink _class={{other:'gui_force_bold'}} _href={platform_base_url + 'promotions/profile/' + log.target} _target="_blank" autotranslate={false}>{this.props.intl.formatMessage({ id:"{promotion} #{id}" }, { promotion: target_name, id:log.target })}</ActionLink>;
				values.element = <FormattedMessage id="domain {domain} in" values={{domain:<strong>"{log?.data?.domain ?? i18n("Unknown")}"</strong>}} />
				break;
		}

		return {
			id:action_text,
			values:values,
		};
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		return (
			<OwnerPromoWrapper
				menu={false}
				add_module={false}
				custom_header={<SectionHeader
					title={i18n("Audit logs")}
					icon={{ icon:'knk-script' }}
					filters={<>
						<Model classname="filter_section gui_equal_columns gui_padded_children_low gui_flex_align_bottom" style={{flexGrow:'1'}} model={this.state.filters} change={this.changeFilter.bind(this)}>
							<Select
								_class={{first:true}}
								name="agent_id"
								values={this.agents_selector}
							>User</Select>

							<Select
								_class={{first:true}}
								name="action"
								values={this.actions_selector}
							>Object</Select>

							<Select
								_class={{first:true}}
								name="type"
								values={this.types_selector}
							>Action</Select>
						</Model>

						<div class="p_filter not_in_top">
							<SearchField
								name="target"
								_class={{first:true, other:'big_search gui_search_input'}}
								model={this.state.filters}
								change={this.changeFilter.bind(this)}
								placeholder="Search by title or ID of the promotion or giveaways"
							/>
						</div>
					</>}
				/>}
			>
				<Module _class={{other:'logs_list gui_pos_rel'}}>
					<table class="gui_list_table gui_huge_dom_content aired_rows" style={{width:'100%'}} cellSpacing="0" cellPadding="0">
						<thead>
							<tr class="list_header gui_pos_rel">
								<th width="55%">{i18n("Action")}</th>
								<th width="15%" class="gui_text_align_center" style={{paddingRight:'20px'}}>{i18n("Date")}</th>
								{(!this.logs_security) && (<th width="15%" class="gui_text_align_center" style={{width:'80px'}}>{i18n("Changes")}</th>)}
								{(!this.logs_security) && (<th width="15%" class="gui_text_align_end" style={{width:'100px'}}>{i18n("Information")}</th>)}
							</tr>
						</thead>
					</table>

					<InfiniteScroll ref={(infinite) => { this.infinite = infinite;}} fetch={(p, cb) => this.fetchLogs(p, cb)} fetched={this.fetched.bind(this)} _maxHeight={{maxHeight:'calc(100dvh - 420px)', minHeight:'20svh'}}>
						{(!this.state.in_progress) ? (
							<table class="gui_list_table aired_rows" style={{width:'100%'}} cellSpacing="0" cellPadding="0">
								<tbody>

									{_size(this.state.logs) > 0 && this.state.logs.map((_log, l) => {
										const log = _log.AgentLog;

										const data = (log.type != logs_type.TYPE_CREATE.id && 
														log.type != logs_type.TYPE_DELETE.id && 
															log.type != logs_type.TYPE_ASSIGN_ROLE.id && 
																log.type != logs_type.TYPE_REMOVE_ROLE.id &&
																log.type != logs_type.TYPE_BLOCK.id &&
																log.type != logs_type.TYPE_UNBLOCK.id &&
																 log.data != undefined) ? convertObjectToArray(log.data) : false;
										var data_filtered = [];
										if(data){
											data.map((item,i)=>{
												var found = false;
												this.fields_not_allowed.map((jtem,j)=>{
													if(item.key == jtem){
														found = true;
														return;
														}
												});
												if(!found)data_filtered.push(item);
											});
										}
										const icon = this.getActionIcon(log.type);

										const agent = this.agents.filter((obj) => { return (obj.Agent.id == log.agent_id) ? true : false; })[0];

										const agent_name = (agent != undefined) ? agent.Agent.name + " " + agent.Agent.lastname : i18n('Unknown');
										const not_me = (agent != undefined) ? (!this.agent_id || agent.Agent.id != this.agent_id) : false;

										const subject = (not_me) ? <span><strong>{agent_name}</strong> {i18n("has")}</span> : <span><strong>{i18n("You")}</strong> {i18n("have")}</span>;
										const action_text = this.getActionText(log, subject);

										var action_text_values = {...action_text.values};
										if(action_text_values.article != undefined) action_text_values.article = i18n(action_text_values.article);

										return (
											<tr key={l}>
												<td width="55%" class={icon + ' gui_small_icon gui_baselined'}>{action_text && action_text.id ? (<FormattedMessage id={action_text.id} values={action_text_values} />) : 'Unknown'}</td>

												<td width="15%" class="gui_text_align_end" style={{paddingRight:'20px'}}>
													{EPDateFromNow(log.created)} <Tooltip autotranslate={false}>{EPDateFormat(log.created, 'llll')}</Tooltip>
												</td>

												{(!this.logs_security) && (
													<td width="15%" class="gui_text_align_center">
														{(_size(data_filtered)>0) ? (
															<ActionLink onClick={() => this.displayDataLayer(data_filtered)} autotranslate={false}>{i18n("View", 'ucfirst')} ({_size(data_filtered)})</ActionLink>
															) : (
																<span>-</span>
														)}
													</td>
												)}
												{(!this.logs_security) && (
												<td width="15%" class="is_floating_actions">
													<ButtonCollection>
														{(log.browser != undefined && log.browser) && (
															<SquaredButton
																icon={`knk-${log.browser}`}
																tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{`${i18n(log.browser, 'ucfirst')}${(log.user_agent != undefined) ? `<br /><br />${log.user_agent}` : ''}`}</Tooltip>}
																aria-label="Browser information"
															/>
														)}

														{(log.device != undefined && log.device) && (
															<SquaredButton
																icon={`knk-${log.device}`}
																tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n(log.device, 'ucfirst')}</Tooltip>}
																aria-label="Device information"
															/>
														)}

														{(log.ip != undefined && log.ip) && (
															<SquaredButton
																icon='knk-tip'
																tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{`${i18n("IP")}: ${log.ip}`}</Tooltip>}
																aria-label="IP"
															/>
														)}
													</ButtonCollection>
												</td>
												)}
											</tr>
										)
									})}
									{(this.state.loading) && (
									<tr class="gui_withoutEvents">
										<td colSpan="4">
											<div class="gui_pos_rel" style={{height:'55px'}}><Spinner force_bg={false}/></div>
										</td>
									</tr>
									)}
									{(_size(this.state.logs) == 0 && !this.state.loading) && (
										<tr class="gui_withoutEvents"><td colSpan="4">{i18n("No logs to show")}</td></tr>

									)}
								</tbody>
							</table>
						) : (
							<LoadingBlock />
						)}
					</InfiniteScroll>
				</Module>

				{(this.state.data_to_display) && (
					<FloatingLayer backButton={() => this.hideDataLayer()}>
						<div class="without_actions">
							<table class="gui_list_table aired_rows gui_huge_dom_content" style={{width:'100%'}} cellSpacing="0" cellPadding="0">
								<thead>
									<tr class="list_header">
										<th>{i18n("Field")}</th>
										<th width="25%">{i18n("From")}</th>
										<th width="25%">{i18n("To")}</th>
									</tr>
								</thead>

								<tbody>
									{this.state.data_to_display.map((log, l) => {
										var old_icon = false;
										var old_v = (log.o != undefined) ? ((typeof log.o != 'object') ? log.o : log.o.name) : this.nullazer;
										if(old_v === true || old_v === "true") {
											old_icon = 'knk-on greenIcon';
											old_v = i18n("Yes");
										}
										if(old_v === false || old_v === "false") {
											old_icon = 'knk-off redIcon';
											old_v = i18n("No");
										}
										if(old_v === this.nullazer || old_v === "") old_v = "-";

										var new_icon = false;
										var new_v = (log.n != undefined) ? ((typeof log.n != 'object') ? log.n : log.n.name) : this.nullazer;
										if(new_v === true || new_v === "true" ) {
											new_icon = 'knk-on greenIcon';
											new_v = i18n("Yes");
										}
										if(new_v === false || new_v === "false") {
											new_icon = 'knk-off redIcon';
											new_v = i18n("No");
										}
										if(new_v === this.nullazer || new_v === "") new_v = "-";

										var field_name = log.key!=undefined ? log.key.replace(/_/g, " ") : ' ';
										switch(log.key) {
											default:
												break;
										}

										return (
											<tr key={l}>
												<td class="name">{i18n(field_name, 'uppercase')}</td>
												<td class={((old_icon) ? old_icon + ' gui_small_icon' : null)}>{(old_v) ? old_v : ""}</td>
												<td class={((new_icon) ? new_icon + ' gui_small_icon' : null)}>{(new_v) ? new_v : ""}</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					</FloatingLayer>
				)}
			</OwnerPromoWrapper>
		)
	}
}

export default injectIntl(AgentsLogs);